export default __webpack_public_path__ + "static/media/token-jolt.6b364466.svg";